import { useEffect, useRef } from 'react';

const LOCATION_WAIT_MS = 6000;

// Browsers differ on whether their own timeout includes time spent on the
// location prompt, so this gives up on screen after 6 seconds instead. A late
// answer is still wanted until the visitor types or chooses a place.
export function useLocationWait(onGiveUp) {
  const timerRef = useRef(null);
  const wantedRef = useRef(false);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  const startWaiting = () => {
    wantedRef.current = true;
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(onGiveUp, LOCATION_WAIT_MS);
  };

  const stopWaiting = () => {
    wantedRef.current = false;
    clearTimeout(timerRef.current);
  };

  const isLocationWanted = () => wantedRef.current;

  return { startWaiting, stopWaiting, isLocationWanted };
}
